import { Observable, Observer } from 'rxjs';

// Gets blob from canvas element. Used 'image/jpg' at 80% quality by default
export function getCanvasBlob(canvas: any, imgType = 'image/jpeg', quality = 80): Observable<Blob> {
  return new Observable((observer: Observer<any>) => {
    if (!HTMLCanvasElement.prototype.toBlob) {
      const binStr = atob(canvas.toDataURL(imgType, quality).split(',')[1]);
      const len = binStr.length;
      const arr = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      observer.next(new Blob([arr], {type: imgType}));
      observer.complete();
    } else {
      canvas.toBlob((blob: any) => {
        observer.next(blob);
        observer.complete();
      }, imgType, quality);
    }
  });
}

/**
 * Method for encoding ArrayBuffer to base64 String
 */
export function arrayBufferToBase64(arrayBuffer: ArrayBuffer) {
  return encodeAb(arrayBuffer);
}

/**
 * Method for decoding base64 String to ArrayBuffer
 */
export function base64ToArrayBuffer(b64: string) {
  return decodeAb(b64);
}

const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
const lookup = new Uint8Array(256);
for (let i = 0; i < chars.length; i++) {
  lookup[chars.charCodeAt(i)] = i;
}
/**
 * BEGIN
 * base64-arraybuffer
 * GitHub @niklasvh
 * Copyright (c) 2012 Niklas von Hertzen
 * MIT License
 */
function encodeAb(arrayBuffer: ArrayBuffer) {
  const bytes = new Uint8Array(arrayBuffer);
  const len = bytes.length;
  let base64 = '';

  for (let i = 0; i < len; i += 3) {
    // eslint-disable-next-line no-bitwise
    base64 += chars[bytes[i] >> 2]
    // eslint-disable-next-line no-bitwise
    base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)]
    // eslint-disable-next-line no-bitwise
    base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)]
    // eslint-disable-next-line no-bitwise
    base64 += chars[bytes[i + 2] & 63]
  }

  if ((len % 3) === 2) {
    base64 = base64.substring(0, base64.length - 1) + '=';
  } else if (len % 3 === 1) {
    base64 = base64.substring(0, base64.length - 2) + '==';
  }

  return base64;
}

function decodeAb(base64: string) {
  const len = base64.length
  let bufferLength = base64.length * 0.75
  let p = 0
  let encoded1
  let encoded2
  let encoded3
  let encoded4

  if (base64[base64.length - 1] === '=') {
    bufferLength--
    if (base64[base64.length - 2] === '=') {
      bufferLength--
    }
  }

  const arrayBuffer = new ArrayBuffer(bufferLength);
  const bytes = new Uint8Array(arrayBuffer);

  for (let i = 0; i < len; i += 4) {
    encoded1 = lookup[base64.charCodeAt(i)]
    encoded2 = lookup[base64.charCodeAt(i + 1)]
    encoded3 = lookup[base64.charCodeAt(i + 2)]
    encoded4 = lookup[base64.charCodeAt(i + 3)]

    // eslint-disable-next-line no-bitwise
    bytes[p++] = (encoded1 << 2) | (encoded2 >> 4)
    // eslint-disable-next-line no-bitwise
    bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2)
    // eslint-disable-next-line no-bitwise
    bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63)
  }

  return arrayBuffer
}

/**
 * END
 * base64-arraybuffer
 */

/**
 * Method for encoding ArrayBuffer into UTF-8 String
 */
export function arrayBufferToString(arrayBuffer: ArrayBuffer) {
  if (typeof arrayBuffer !== 'object') {
    throw new TypeError('Expected input of arrayBuffer to be an ArrayBuffer Object')
  }

  const decoder = new TextDecoder('utf-8')
  return decoder.decode(arrayBuffer)
}

/**
 * Method for decoding String to ArrayBuffer
 */
export function stringToArrayBuffer(str: string) {
  const encoder = new TextEncoder();
  const byteArray = encoder.encode(str);
  return byteArray.buffer;
}
